import { ResponsiveLine } from "@nivo/line";

const PatientHealthLine = () => {
  const data = [
    {
      id: "Heart Rate",
      data: [
        { x: "Mon", y: 72 },
        { x: "Tue", y: 76 },
        { x: "Wed", y: 74 },
        { x: "Thu", y: 78 },
        { x: "Fri", y: 73 },
      ],
    },
  ];

  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 h-96">
      <h3 className="text-lg font-semibold text-slate-700 mb-4">
        Heart Rate Trend
      </h3>

      <ResponsiveLine
        data={data}
        margin={{ top: 20, right: 20, bottom: 50, left: 50 }}
        xScale={{ type: "point" }}
        yScale={{ type: "linear", min: 60, max: 100 }}
        curve="catmullRom"
        enableArea={true}
        areaOpacity={0.08}
        colors={["#2563EB"]}
        pointSize={8}
        pointColor="#ffffff"
        pointBorderWidth={3}
        pointBorderColor="#2563EB"
        enableGridX={false}
        theme={{
          axis: {
            ticks: { text: { fill: "#64748B" } },
          },
          grid: { line: { stroke: "#E2E8F0" } },
        }}
        useMesh={true}
      />
    </div>
  );
};

export default PatientHealthLine;